<template>  
    <div id="footer">
        <b-alert show type="dark" variant="dark">
            <b-link href="#">Cookies</b-link> 
            <br>
            <b-link href="#">Aviso legal</b-link>
            <br>
            <b-link href="#">Politicas de privacidad</b-link> 
            <br>
            <b-link href="#">Hojas de reclamaciones</b-link>
            <br>
            <b-link href="#">Descarga de resposabilidad</b-link>
            <br>
            <b-link href="#">Politica de grabacion de conciertos</b-link>
            <br>
            <p><strong>Todos los derechos reservados a - ROCK RECORDS</strong></p>
        </b-alert>
    </div>


</template>

<script>
export default {


}
</script>


<style>
#footer{
    font-family: Avenir, Helvetica, Arial, sans-serif;
    text-align:justify;
}
</style>